import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { nameDecorator } from 'helpers/name';
import { phoneDecorator } from 'helpers/phone';

import { ReactComponent as PhoneSVG } from 'icons/phone.svg';
import { ReactComponent as EmailSVG } from 'icons/email.svg';
import { ReactComponent as PinSVG } from 'icons/pin.svg';
import { ReactComponent as CheckBadgeSVG } from 'icons/check-badge.svg';
import { ReactComponent as PatientRightsSVG } from 'icons/patient-rights.svg';

import { PATIENT_RIGHTS_OPTIONS } from 'config/customer';

import useWindowDimensions, {
  isMobileResolution,
} from 'helpers/useWindowDimensions';

const CustomerHeaderCard = ({ data, role, isTeleconsultation }) => {
  const { width } = useWindowDimensions();
  const isMobile = isMobileResolution(width);

  return (
    <div className="pa5 pt4 br4 shadow-1 bg-grouped-table flex flex-column justify-between">
      <h3 className="flex align-center f2 fw6 ma0 pa0">
        {isTeleconsultation ? (
          <Link
            className="darkgrey hover-underline"
            to={`/customers/${data.id}`}
          >
            {nameDecorator(data.firstName, data.lastName)}
          </Link>
        ) : (
          nameDecorator(data.firstName, data.lastName)
        )}
        {data.user && (
          <CheckBadgeSVG
            data-rh="This patient has an active SleepDoctor account"
            className="h6 w6 ml3 purple"
          />
        )}
      </h3>
      <div
        className={
          isMobile
            ? 'mt6 flex flex-column middarkgrey'
            : 'mt6 flex margin-between middarkgrey'
        }
        style={{ gap: '16px' }}
      >
        {data.phone && (
          <div className="flex items-center f7 ma0 nudge-bottom--2">
            <PhoneSVG className="h6 w6 mr2" />
            <a className="middarkgrey underline" href={`tel:${data.phone}`}>
              {phoneDecorator(data.phone)}
            </a>
          </div>
        )}
        <div className="flex items-center f7 ma0 nudge-bottom--2">
          <EmailSVG className="h6 w6 mr2" />
          <a className="middarkgrey underline" href={`mailto:${data.email}`}>
            {data.email}
          </a>
        </div>
        {role !== 'admin' && data.city && (
          <div className="flex items-center f7 ma0 nudge-bottom--2">
            <PinSVG className="h6 w6 mr2" />
            {data.city}
          </div>
        )}
        {role === 'admin' && data.patientRights && (
          <div className="flex items-center f7 ma0 nudge-bottom--2">
            <PatientRightsSVG className="h6 w6 mr2" />
            {
              PATIENT_RIGHTS_OPTIONS.find((o) => o.id === data.patientRights)
                .label
            }
          </div>
        )}
      </div>
    </div>
  );
};

CustomerHeaderCard.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    description: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    city: PropTypes.string,
    address: PropTypes.string,
  }),
  role: PropTypes.string,
  isTeleconsultation: PropTypes.bool,
};

export default CustomerHeaderCard;
